import TextareaAutosize from "react-textarea-autosize";
export default function AutosizeInput({
  value,
  onChange,
  label,
  placeholder,
  styles = "",
  wrapperStyles = "",
  labelStyles = "",
  extraInfoLines,
}) {
  return (
    <div className={`grid gap-y-2 ${wrapperStyles} `}>
      <div className="flex truncate space-x-3 items-center">
        <p
          className={`text-base ${
            !extraInfoLines && "truncate"
          } ${labelStyles}`}
        >
          {label}
        </p>
        {extraInfoLines && (
          <span
            className={`flex gap-1 truncate justify-center before:content-['('] after:content-[')'] before:mb-0.5 after:mb-0.5 `}
          >
            <span className="flex flex-col truncate justify-center">
              {extraInfoLines.map((text) => (
                <p
                  key={text}
                  className={`font-semibold text-xs text-[#0D0C22] truncate ${labelStyles}`}
                >
                  {text}
                </p>
              ))}
            </span>
          </span>
        )}
      </div>
      <div className="relative mb-4">
        <div className="relative min-w-[50%] flex-1">
          <TextareaAutosize
            name="texto"
            placeholder={placeholder}
            value={value}
            onChange={onChange}
            className={`peer border border-[#dcdcdc] h-[40px] focus:outline-none rounded-lg p-2 w-80 lg:w-full ${styles} pt-3`}
            required={value == "" ? true : false}
            maxLength={1000}
            autoCorrect={false}
          />
          <span className="absolute top-[2px] right-1 text-xs text-nimbusLight font-bold">
            {value && value.length + " / 1000"}
          </span>
        </div>
      </div>
    </div>
  );
}
